import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { PppoeListPage } from '@/features/monitoring'

export const Route = createFileRoute('/_authenticated/monitoring/pppoe')({
  component: () => (
    <RequirePermission permission='monitoring.read'>
      <PppoeListPage />
    </RequirePermission>
  ),
})
